import type { Action, ThunkOn } from 'easy-peasy';
import { action, thunkOn } from 'easy-peasy';
import uuid from 'uuid-random';
import type { StoreModel } from '..';
import type { ApplicationError, ApplicationErrorOptions } from '../../types';

const MAX_ERRORS = 10;

export interface ErrorModel {
  errors: ApplicationError[];
  throwApplicationError: Action<ErrorModel, ApplicationErrorOptions>;
  acknowlegeApplicationError: Action<ErrorModel, string>;
  onApplicationError: ThunkOn<ErrorModel, void, StoreModel>;
}

export const errorModel: ErrorModel = {
  errors: [],

  onApplicationError: thunkOn(
    (actions, storeActions) => [
      storeActions.session.authenticationFailure,
      storeActions.users.addUserFailure,
      storeActions.users.fetchUsersFailure,
      storeActions.partner.partnerEmailVerificationFailure,
      storeActions.partner.partnerConfigFailure,
      storeActions.loading.loadingFailure,
      storeActions.fulfillmentCenterConfig.saveFulfillmentCentersFailure,
      storeActions.fulfillmentCenterConfig.fetchFulfillmentCentersFailure,
      storeActions.carrier.carrierFailure,
      storeActions.file.deleteUploadError,
      storeActions.file.uploadError,
      storeActions.siteReporting.siteReportActionFailure,
      storeActions.security.oauthClientFailure,
      storeActions.tracking.trackingError,
      storeActions.shipments.shipmentActionFailure,
      storeActions.limit.limitFailure,
      storeActions.qztray.qzTrayActionFailure,
      storeActions.partnerConfiguration.origins.pcOriginFailure,
      storeActions.thirdPartyBilling.thirdPartyBillingAccountFailure,
      storeActions.FP_fulfillmentContext.mutateFulfillmentContextFailure,
      storeActions.FP_fulfillmentContext.fetchFulfillmentContextDetailsFailure,
      storeActions.FP_fulfillmentContext.fetchFulfillmentContextDetailFailure,
      storeActions.FP_fulfillmentContext.mutateFedexRegistrationFailure,
      storeActions.simulation.simulationActionFailure,
    ],
    (actions, payload) => {
      payload.payload.sourceAction = payload.type;
      actions.throwApplicationError(payload.payload);
      // Note: 401 handling (token refresh + retry) is now handled by the axios interceptor
      // in GatewayAxiosClient.ts, which provides automatic retry of the failed request
    },
  ),
  throwApplicationError: action((state, errorArg) => {
    const errorAction = errorArg.sourceAction;
    const error = errorArg instanceof Error ? errorArg : errorArg.error;
    const asNotification = !errorArg.hasOwnProperty('asNotification') ? true : errorArg.asNotification;
    const duration = errorArg.hasOwnProperty('duration') ? (errorArg as any).duration : undefined;
    const message = errorArg instanceof Error ? error.message : errorArg.message;
    const link = errorArg.hasOwnProperty('duration') ? (errorArg as any).link : undefined;
    const applicationError: ApplicationError = {
      id: uuid(),
      error,
      message,
      asNotification,
      duration,
      timestamp: Date.now(),
      acknowledgedTimestamp: asNotification ? Date.now() : undefined,
      link,
      sourceAction: errorAction,
    };
    state.errors.push(applicationError);
    state.errors.sort((a, b) => b.timestamp - a.timestamp);
    state.errors.slice(0, MAX_ERRORS);
  }),

  acknowlegeApplicationError: action((state, errorId) => {
    const error = state.errors.find((err) => err.id === errorId);
    if (error) {
      error.acknowledgedTimestamp = Date.now();
    }
  }),
};
